import { useQuery } from '@tanstack/react-query'
import type { ResumoDaEntrada } from '@crm/shared'
import { api } from './cliente'

/**
 * Os números do dia, para a tela de entrada.
 *
 * Não fica no cache entre sessões (`staleTime: 0`): a tela só aparece quando
 * alguém entra, e o sentido dela é dizer como as coisas estão **agora**. Um
 * número guardado de ontem seria pior do que número nenhum.
 */
export function useResumoDaEntrada(habilitado = true) {
  return useQuery({
    queryKey: ['entrada', 'resumo'],
    queryFn: () => api<ResumoDaEntrada>('/api/entrada/resumo'),
    enabled: habilitado,
    staleTime: 0,
    /*
      Uma tentativa só. A tela tem tempo contado; insistir três vezes faria a
      espera passar do tempo da tela por causa de um número que é enfeite perto
      do que importa, que é o sistema carregar atrás.
    */
    retry: false,
  })
}
